import { useHistorico } from "../contexts/HistoricoContext";
import { EmpreenderApps } from "../files/AppsArray";
import { compactarArtigo, gravarConversas, lerConversas } from "../lib/armazenamento";

const { v4: uuidv4 } = require("uuid");

type Mensagem = {
  usuario?: string;
  assistente?: string;
};

export const useSalvarConversaNoStorage = () => {
  const { historicoApps, recarregarHistorico } = useHistorico();

  const salvarConversa = (
    slug: string,
    conversaId: string,
    mensagem: Mensagem,
    artigos?: any[],
    whatsapps?: any[],
    idRespostaGptSak?: number | null,
    // Campos extras da mensagem (ex.: anexoTexto, o texto lido do print).
    extras?: Record<string, unknown>
  ) => {
    const dadosApp = EmpreenderApps.find(
      (item) => item.slug === slug || item.sluges === slug
    );

    const slugAmigavel = dadosApp?.slugamigavel || "";

    const conversasStorage = lerConversas();

    if (!conversasStorage[slugAmigavel]) {
      conversasStorage[slugAmigavel] = {};
    }
    if (!conversasStorage[slugAmigavel][conversaId]) {
      conversasStorage[slugAmigavel][conversaId] = [];
    }

    const historicoAtual = conversasStorage[slugAmigavel][conversaId];
    const novaMensagemTexto = mensagem.usuario || mensagem.assistente;
    const novoTipo = mensagem.usuario ? "usuario" : "assistente";

    const ultimaMensagem = historicoAtual[historicoAtual.length - 1];
    const mensagemDuplicada =
      ultimaMensagem &&
      ultimaMensagem.texto === novaMensagemTexto &&
      ultimaMensagem.tipo === novoTipo;

    if (mensagemDuplicada) {
      return;
    }

    const mensagemId = uuidv4();
    const novaMensagem = {
      id: mensagemId,
      texto: novaMensagemTexto,
      tipo: novoTipo,
      idRespostaGptSak: idRespostaGptSak,
      // Só o resumo de cada artigo e o link do vídeo; o HTML inteiro enchia o localStorage.
      artigos: mensagem.assistente ? (artigos || []).map(compactarArtigo) : [],
      whatsapps: mensagem.assistente ? whatsapps : [],
      ...extras,
    };

    historicoAtual.push(novaMensagem);

    conversasStorage[slugAmigavel][conversaId] = historicoAtual;
    gravarConversas(conversasStorage, { app: slugAmigavel, conversa: conversaId });

    recarregarHistorico();
  };

  // Grava campos extras numa mensagem já salva (ex.: a resposta do "Isso resolveu?").
  const atualizarMensagem = (
    slug: string,
    conversaId: string,
    mensagemId: string,
    campos: Record<string, unknown>
  ) => {
    const dadosApp = EmpreenderApps.find(
      (item) => item.slug === slug || item.sluges === slug
    );
    const slugAmigavel = dadosApp?.slugamigavel || "";

    const conversasStorage = lerConversas();
    const mensagens = conversasStorage[slugAmigavel]?.[conversaId];
    const mensagem = mensagens?.find((m: { id: string }) => m.id === mensagemId);
    if (!mensagem) return;

    Object.assign(mensagem, campos);
    gravarConversas(conversasStorage, { app: slugAmigavel, conversa: conversaId });

    recarregarHistorico();
  };

  return { salvarConversa, atualizarMensagem, historicoApps };
};
